import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Banner from "../../components/general/Banner";
import Celikler from "../../components/general/Celikler";
import { fetchPageGetSlug } from "../../redux/slices/pageGetSlugSlice";
import { fetchSeoGet } from "../../redux/slices/seoGetSlice";
import Tabs from "./Tabs";

const CMS = () => {
    const page = useSelector((state) => state.pageGetSlug.data);
    const lang = useSelector((state) => state.lang.lang);
    const seo = useSelector((state) => state.seoGet.data);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const { slug } = useParams();

    const getData = async () => {
        setLoading(true)
        await dispatch(fetchPageGetSlug({ slug: slug }));
        await dispatch(fetchSeoGet({ slug: slug }));
        setLoading(false)
    }

    useEffect(() => { getData() }, [])

    return (
        !loading && page?.pageType && page?.pageType !== 0 ? <Celikler>
            {seo && seo.title && seo.description && (
                <Helmet>
                    <title>{seo.title?.[lang] || "Çelikler Enerji"}</title>
                    <meta name="description" content={seo.description?.[lang] || ""} />
                    <meta name="keywords" content={seo.keywords?.[lang] || ""} />
                    <meta name="robots" content="index, follow" />
                    <link rel="canonical" href={window.location.href} />
                </Helmet>
            )}
            <Banner title={page?.showcases[0]?.title[lang]} />

            <Tabs data={page?.showcases[0]} lang={lang} index={page?.pageType} />

        </Celikler> : <div className="modern-spinner-wrapper">
            <div className="modern-spinner"></div>
        </div>
    )
}

export default CMS
